import { useFigures } from '@cibo/ui'
import { Chip, ChipProps } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { statusChipColor, statusIcon } from './StatusUIMaps'
import { AgreementModel } from './models'

interface AgreementStatusChipProps extends ChipProps {
  agreement: AgreementModel
  concise?: boolean
}

export const AgreementStatusChip = ({
  agreement,
  concise = false,
  ...rest
}: AgreementStatusChipProps) => {
  const { t } = useTranslation(`@cibo/impact/components/AgreementStatusChip`)
  const { modifiedDate } = useFigures()
  const { agreementId, agreementType, status } = agreement

  if (
    (agreementType === 'dataCollection' && status === 'concluded') ||
    agreementType === 'soilHealth'
  ) {
    return null
  }

  return (
    <Chip
      data-testid={`agreement-status-chip_${agreementId}`}
      icon={concise ? undefined : statusIcon[status]}
      color={statusChipColor[agreementType || 'dataCollection'][status]}
      label={`${t(concise ? `conciseChip_${status}` : `chip_${status}`)} ${
        agreement.modifiedDate && !concise
          ? modifiedDate(agreement.publicationDateTime || agreement.modifiedDate)
          : ''
      }`}
      {...rest}
    />
  )
}
